<script setup lang="ts">
import type { NavigationTreeFragment } from '#graphql-operations'

interface HeaderNavProps {
  nav: NavigationTreeFragment[]
}

defineProps<HeaderNavProps>()
</script>

<template>
  <nav v-if="nav && nav.length > 0" class="headerNav desktop-only">
    <ul class="flex gap-7.5 items-center">
      <template v-for="item in nav" :key="item.id">
        <template v-if="item">
          <HeaderNavSubmenu v-if="(item.children?.length || 0) > 0" :nav="item" />
          <HeaderNavLink v-else :link="item" />
        </template>
      </template>
      <slot />
    </ul>
  </nav>
</template>
